import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { NgClass, NgStyle } from '@angular/common';
import { SkeletonLoadingRowComponent } from '@legacy/common-ui-shared';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

import { backgroundImageFromRendering } from '../../helpers';

@Component({
  selector: 'wl-row-container-solo',
  templateUrl: './row-container-solo.component.html',
  styleUrls: ['./row-container-solo.component.scss'],
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    JssModule,
    NgClass,
    NgStyle,
    SkeletonLoadingRowComponent,
    ExperienceEditorPreviewDirective,
  ],
})
export class RowContainerSoloComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundTheme = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() textTheme = '';
  backgroundImageCss = {};

  ngOnInit() {
    this.renderingToModel(this.rendering);
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.backgroundTheme = `${getItemLinkFieldValue(
      rendering.fields,
      'backgroundTheme',
      ''
    )}`;

    this.textTheme = `${getItemLinkFieldValue(
      rendering.fields,
      'textTheme',
      ''
    )}`;

    this.backgroundImageCss = backgroundImageFromRendering(rendering);
  }
}
